import PropTypes from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

import { t } from '../../../../modules/infra/i18n';
import Checkbox from '../../../common/Checkbox';
import Pill from '../../../common/Pill';

const getAssignmentStatusText = (status) => {
  switch (status) {
    case 'assigned':
      return t('memberships:membership_shops.status.assigned');
    case 'unassigned':
      return t('memberships:membership_shops.status.unassigned');
    default:
      return status;
  }
};

const getOwnerTypeText = (ownerType) => {
  switch (ownerType) {
    case 'shop':
      return t('memberships:membership_shops.owner_type.shop');
    case 'brand':
      return t('memberships:membership_shops.owner_type.brand');
    default:
      return ownerType;
  }
};

const MembershipShops = (props) => (
  <div className="u-width-100">
    <div className="c-membership-stats-container u-mt+">
      <div className="c-memberships-container">
        <div className="c-memberships-container__text_small">{t('memberships:membership_shops.created_by')}</div>
        <div className="c-memberships-container__title">{getOwnerTypeText(props.membershipOwnerType)}</div>
      </div>
      <div className="c-memberships-container">
        <div className="c-memberships-container__text_small">
          {t('memberships:membership_shops.locations_assigned')}
        </div>
        <div className="c-memberships-container__title">
          {props.assignedLocations}/{props.totalLocations}
        </div>
      </div>
      <div className="c-memberships-container">
        <div className="c-memberships-container__text_small">{t('memberships:membership_shops.total_members')}</div>
        <div className="c-memberships-container__title">{props.totalMembers}</div>
      </div>
      <div className="c-memberships-container">
        <div className="c-memberships-container__text_small">{t('memberships:membership_shops.active_members')}</div>
        <div className="c-memberships-container__title">{props.activeMembers}</div>
      </div>
    </div>
    <div className="u-text-right u-mt+">
      <button
        disabled={!props.canSaveAssignment || props.busy}
        className="c-btn c-btn--medium"
        onClick={props.saveAssignments}
      >
        {t('memberships:membership_shops.assign_locations_button')}
      </button>
    </div>
    <ReactTable
      className="c-table-new c-table-paginated c-no-hover u-mt+ u-mb"
      data={props.items}
      minRows={0}
      defaultPageSize={2000}
      showPagination={false}
      resizable={false}
      noDataText={t('memberships:common.no_rows_found')}
      columns={[
        {
          Header: t('memberships:membership_shops.table.assignment_header'),
          accessor: (row) => props.shopAssignments[row.shopId],
          id: 'assignment',
          maxWidth: 80,
          Cell: (row) => (
            <div>
              <Checkbox
                checked={row.value}
                disabled={props.busy}
                onChange={() => props.toggleAssignment(row.original)}
              />
            </div>
          ),
        },
        {
          Header: t('memberships:membership_shops.table.location_header'),
          accessor: 'name',
          id: 'name',
          Cell: (row) => (
            <div>
              {row.value}{' '}
              <Pill type="primary" className="u-ml-" display-if={row.original.isCreator}>
                {t('memberships:membership_shops.creator_pill')}
              </Pill>
            </div>
          ),
        },
        {
          Header: t('memberships:membership_shops.table.members_header'),
          accessor: (row) => (row.counts ? row.counts.total : 'N/A'),
          id: 'total',
        },
        {
          Header: t('memberships:membership_shops.table.active_members_header'),
          accessor: (row) => (row.counts ? row.counts.active : 'N/A'),
          id: 'active',
        },
        {
          Header: t('memberships:membership_shops.table.status_header'),
          accessor: 'status',
          id: 'status',
          Cell: (row) => (
            <div className={`c-memberships-status c-memberships-status__${row.value}`}>
              {getAssignmentStatusText(row.value)}
            </div>
          ),
        },
      ]}
    />
  </div>
);

MembershipShops.propTypes = {
  membershipOwnerType: PropTypes.string.isRequired,
  assignedLocations: PropTypes.number.isRequired,
  totalLocations: PropTypes.number.isRequired,
  totalMembers: PropTypes.number.isRequired,
  activeMembers: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
  canSaveAssignment: PropTypes.bool.isRequired,
  busy: PropTypes.bool.isRequired,
  toggleAssignment: PropTypes.func.isRequired,
  saveAssignments: PropTypes.func.isRequired,
  shopAssignments: PropTypes.object.isRequired,
};

export default MembershipShops;
